// extracted by mini-css-extract-plugin
module.exports = {"card":"TischOffensives_card__1URGW"};